import { useState } from 'react'
import { StorageProvider } from 'providers/storage'

export const usePersistedState = (key: string, initialValue?: any) => {
  const [persistedValue, setPersistedValue] = useState(() => {
    return StorageProvider.get(key) ?? initialValue
  })

  const persistValue = (value: any) => {
    // We do this check to keep the original useState API https://reactjs.org/docs/hooks-reference.html#functional-updates
    const newValue = value instanceof Function ? value(persistedValue) : value
    setPersistedValue(newValue)
    StorageProvider.set(key, newValue)
  }

  return [persistedValue, persistValue]
}
